import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { EventSectionClickLayer } from '../../../../../../../types/query/event';

const useClickLayerState = (
  initState?: EventSectionClickLayer[],
): [EventSectionClickLayer[] | undefined, Dispatch<SetStateAction<EventSectionClickLayer[] | undefined>>] => {
  const [clickLayerState, setClickLayerState] = useState(initState);
  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (!isFirst || !initState) return;
    setClickLayerState(initState);
    setIsFirst(false);
  }, [initState]);

  return [clickLayerState, setClickLayerState];
};

export default useClickLayerState;
